(function () {
    angular.module('tradersyard').component('tyChoopChatConferencing', {
        template: `
            <div class="row" style="margin-top: 10px;" ng-if="$ctrl.webinarIframeOpen">
                <div class="c-12">
                    <div class="card webinar-stream-close">
                        <div class="stream-action">
                            <span class="open-webinar-icon" ng-click="$ctrl.openInPopup()"></span>
                        </div>
                        <div id="webinar-stream-root" class="webinar-stream-root">
                            <ty-video-conference-app meeting-id="$ctrl.webinarIframeMeetingId" enable-chat="false" on-hangup="$ctrl.onHangup()"></ty-video-conference-app>
                        </div>
                    </div>
                </div>
            </div>
        `,
        bindings: {
            webinarIframeType: '<',
            webinarIframeId: '<',
            webinarIframeOpen: '<',
            webinarIframeMeetingId: '<',
        },
        controller: ChoopChatConferencingController,
    });

    ChoopChatConferencingController.$inject = [
        'MeetingService',
        '$window',
        'NativeNotificationService',
        '$timeout',
        '$scope',
    ];

    /**
     * Component responsible for displaying <ty-video-conference-app /> embedded on a page instead of being open in a popup.
     * It tracks the open state of conference and notifies users when they leave a running conference allowing them to re-open it
     * by clicking notification.
     *
     * It's also possible to open a popup of running conference, but then we need to sync state of audio/video toggles.
     *
     * TODO: sync audio/video toggles
     *
     * @param MeetingService
     * @param $window
     * @param NativeNotificationService
     * @param $timeout
     * @param $scope
     * @constructor
     */
    function ChoopChatConferencingController(MeetingService, $window, NativeNotificationService, $timeout, $scope) {
        const ctrl = this;

        let jitsi,
            jistiParams = {
                muted_audio: false,
                muted_video: false,
                share_screen: false,
                toggle_view: false,
            };

        ctrl.$onChanges = function (changes) {
            if (changes.webinarIframeOpen.currentValue !== true) {
                return;
            }

            $window.onbeforeunload = function (event) {
                ctrl.onBeforeUnload();
            };
        };

        ctrl.onHangup = () => {
            $scope.$parent.webMeting.open = false;
            localStorage.removeItem('webinarIframeUrl');
        };

        ctrl.openInPopup = () => {
            $scope.$parent.webMeting.open = false;
            localStorage.removeItem('webinarIframeUrl');
            // TODO: pass audio/video toggles as parameter
            MeetingService.openVideoConferencePopup(ctrl.webinarIframeMeetingId);
        };

        ctrl.onBeforeUnload = function () {
            if (ctrl.webinarIframeOpen === true) {
                localStorage.setItem(
                    'webinarIframeUrl',
                    MeetingService.getVideoConferenceUrl(ctrl.webinarIframeMeetingId)
                );
            }
        };
    }
})();
